import { type FC } from "react";
import { z } from "zod";
import type { InputProps } from "../../DynamicInput";
import { MailIcon } from "../../../shared/icons";
import { Text } from "./Text";

const emailParser = z.string().email();

export const Email: FC<InputProps<string>> = props => {
  return (
    <Text
      {...props}
      Icon={MailIcon}
      validation={{
        validator: value => !value || emailParser.safeParse(value).success,
        errorMessageKey: "Input.Validation.RequiredEmail",
      }}
    />
  );
};
